import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Typography, Container } from "@mui/material";
import Grid from "@mui/material/Grid";
import swal from "sweetalert2";
import ButtonWithProgress from "component/ButtonWithProgress/ButtonWithProgress";
import * as authActions from "component/authActions";
import { connect } from "react-redux";
import { FormControl, TextField, InputLabel } from "@mui/material";
import Button from "@mui/material/Button";
import Zoom from "@mui/material/Zoom";
import { Link } from "react-router-dom";
import { getEmpresasByCuentaContrato } from "component/api";
import "./SingleLogInForm.css";

const SingleLogInForm = (props) => {
  const textsLoginPage = props.textsLoginPage;
  const startText = props.startText;
  const [toggle, setToggle] = useState(false);

  const validation = Yup.object({
    user: Yup.string().required(
      <Typography
        variant="p"
        style={{ fontSize: "12pt", textTransform: "none" }}
      >
        requerido
      </Typography>
    ),
    password: Yup.string()
      .min(
        6,
        <Typography
          variant="p"
          style={{ fontSize: "12pt", textTransform: "none" }}
        >
          "La contraseña debe tener al menos 6 caracteres"
        </Typography>
      )
      .required(
        <Typography
          variant="p"
          style={{ fontSize: "12pt", textTransform: "none" }}
        >
          requerido
        </Typography>
      ),
  });

  const handleToggle = () => {
    setToggle(!toggle);
  };
  const formik = useFormik({
    initialValues: {
      cuentaContrato: "",
      user: "",
      password: "",
    },
    validationSchema: validation,
  });

  const link = props.link;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [apiError, setApiError] = useState();
  const [pendingApiCall, setPendingApiCall] = useState(false);
  const [backGroundColorButton, setBackGroundColorButton] = useState("#B1B0AF");

  let empresa = [];
  async function getEmpresasByCuentaContratoFunc(cc) {
    if (cc !== null) {
      const res = await getEmpresasByCuentaContrato(cc);
      empresa = res.data;
      localStorage.setItem("empresaNombre", empresa.razonSocial);
      localStorage.setItem("empresaId", empresa.id);
    }
  }

  function changeButtonColor() {
    let cuentaContratoTextField =
      document.getElementById("cuentaContrato").value;
    let contraseñaTextField = document.getElementById("contraseña").value;
    if (cuentaContratoTextField !== "" && contraseñaTextField !== "") {
      setBackGroundColorButton("#009BDB");
      disableSubmit = false;
    } else {
      disableSubmit = true;
      setBackGroundColorButton("#B1B0AF");
    }
  }

  useEffect(() => {
    changeButtonColor();
    setApiError(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username, password]);

  function swalWarning() {
    swal.fire({
      title: "Credenciales inválidas",
      text: "Por favor ingresar usuario y contraseña correctos",
      icon: "warning",
      confirmButtonColor: "#009bdb",
      confirmButtonText: "ok",
      showCancelButton: false,
      cancelButtonText: "No",
      cancelButtonColor: "#b7b7b7",
      
    });
  }
  /* const rol = props.rol;
  const rolAdmin = "ROLE_ADMIN";
  const rolVaciadero = "ROLE_VACIADERO"; */

  /*  const linkAysa = "./backofficeAysaLogeado";
  const linkVaciadero = "./backofficeVaciaderoLogeado"; */

  const onClickLogin = () => {
    formik.handleSubmit();

    const body = {
      username,
      password,
    };
    const bodyParseado = JSON.stringify(body);

    setPendingApiCall(true);
    props.actions
      .postLogin(body)
      .then((response) => {
        if (response.data.username !== null) {
          localStorage.setItem("userEmpresa", response.data.username);
          localStorage.setItem("rol", response.data.roles[0].name);
          sessionStorage.setItem("logeado", true);
          sessionStorage.setItem("body", bodyParseado);
          setPendingApiCall(false);
          window.location.replace(link);
        } else {
          sessionStorage.setItem("logeado", false);
          setPendingApiCall(false);
          setApiError("Usuario o contraseña invalido !");
          swalWarning();
        }
      })
      .catch((error) => {
        if (error.response) {
          setPendingApiCall(false);
          setApiError("Usuario o contraseña invalido !");
          swalWarning();
        }
      });
  };

  let disableSubmit = false;
  if (username === "") {
    disableSubmit = true;
  }
  if (password === "") {
    disableSubmit = true;
  }

  function onChangeUsuario(value) {
    if (isNaN(value) === false && value.length <= 7) {
      setUsername("00000" + value);
      localStorage.setItem("cuentaContrato", "00000" + value);
    }
    if (isNaN(value) === false && value.length == 12) {
      setUsername(value);
      localStorage.setItem("cuentaContrato", value);
    }
    if (isNaN(value) === true && textsLoginPage !== true) {
      setUsername(value);
    }
    getEmpresasByCuentaContratoFunc(localStorage.getItem("cuentaContrato"));
  }
  function onChangePassWord(value) {
    setPassword(value);
  }

  return (
    <div>
      <Container maxWidth="sm">
        {startText === "login" ? (
          <div>
            <p
              style={{
                color: "#4A4A4A",
                lineHeight: "42px",
                fontSize: "36px",
                fontWeight: "bold",
                fontStyle: "normal",
                fontFamily: "Roboto",
              }}
            >
              Ingresá para gestionar tus vales de vaciaderos
            </p>
            <p
              style={{
                color: "#4A4A4A",
                lineHeight: "21px",
                fontSize: "18px",
                fontWeight: "normal",
                fontStyle: "normal",
                fontFamily: "Roboto",
              }}
            >
              Para empezar, ingresá tu número de Cuenta y contraseña
            </p>
          </div>
        ) : (
          <h1>Iniciar sesión</h1>
        )}

        <form
          onSubmit={formik.handleSubmit}
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <FormControl className="form-control__single-form">
            <InputLabel style={{ width: "100%", fontWeight: "bold" }}>
              {" "}
              <Grid container sx={{ width: "100%" }}>
                <Grid size="grow">
                  {startText === "login" ? "N° Cuenta" : "Usuario"}
                </Grid>
              </Grid>
            </InputLabel>

            <TextField
              className="text-field__single-form"
              onChange={(event) => {
                onChangeUsuario(event.target.value);
              }}
              style={{ marginBottom: "2%" }}
              placeholder={
                startText === "login"
                  ? "Ingresá tu número de cuenta"
                  : "Usuario"
              }
              id="cuentaContrato"
              name="cuentaContrato"
              variant="outlined"
              helperText={formik.errors.cuentaContrato}
              error={formik.errors.cuentaContrato}
            />
          </FormControl>
          {textsLoginPage === true && (
            <div style={{ alignSelf: "flex-end" }}>
              <Button
                onClick={handleToggle}
                style={{ height: "3px", marginTop: "0%", marginBottom: "2%" }}
              >
                <p
                  style={{
                    fontFamily: "Roboto",
                    textTransform: "none",
                    color: "#009bdb",
                    fontSize: "13px",
                    lineHeight: "16px",
                    letterSpacing: "0.4px",
                  }}
                >
                  ¿Dónde encuentro mi N° de cuenta?
                </p>
              </Button>

              <div>
                <Zoom in={toggle}>
                  <div>
                    {toggle && (
                      <img
                        id="service"
                        style={{ width: "75%", height: "50%" }}
                        src="https://aysa.com.ar/media-library/vaciadero/factura_eventual.png"
                        alt="imagen-factura"
                      ></img>
                    )}
                  </div>
                </Zoom>
              </div>
            </div>
          )}

          <FormControl className="form-control__single-form">
            <InputLabel style={{ width: "100%", fontWeight: "bold" }}>
              {" "}
              <Grid container sx={{ width: "100%" }}>
                <Grid size="grow">
                  Contraseña
                </Grid>
              </Grid>
            </InputLabel>
            <TextField
              onClick={formik.handleChange}
              className="text-field__single-form"
              onChange={(event) => {
                onChangePassWord(event.target.value);
              }}
              style={{ marginBottom: "2%" }}
              placeholder="Ingresá la contraseña"
              id="contraseña"
              name="contraseña"
              type="password"
              variant="outlined"
              helperText={formik.errors.contraseña}
              error={formik.errors.contraseña}
            />
          </FormControl>
          <div style={{ alignSelf: "flex-end" }}>
            {textsLoginPage === true && (
              <Link
                to="/recuperar"
                style={{
                  textDecoration: "none",
                  color: "#009bdb",
                  fontSize: "13px",
                  lineHeight: "16px",
                  letterSpacing: "0.4px",
                }}
              >
                {" "}
                No recuerdo mi contraseña
              </Link>
            )}
          </div>
          {apiError && (
            <div className="col-12 mb-3">
              <div className="alert alert-danger">{apiError}</div>
            </div>
          )}
          <br />
          <div style={{ fontSize: "10%", alignSelf: "center" }}>
            <ButtonWithProgress
              backGroundColorButton={backGroundColorButton}
              onClick={onClickLogin}
              disabled={disableSubmit || pendingApiCall}
              text="Ingresar"
              pendingApiCall={pendingApiCall}
            />
          </div>
          <br />
          {textsLoginPage === true && (
            <a
              style={{
                textDecoration: "none",
                alignSelf: "center",
                textTransform: "none",
                color: "blue",
              }}
              href={
                "https://aysa.com.ar/media-library/vaciadero/Instructivo_registro_vaciadero.pdf"
              }
            >
              <p
                style={{
                  fontFamily: "Roboto",
                  fontSize: "17px",
                  lineHeight: "20px",
                  textDecoration: "none",
                  justifyContent: "center",
                  alignSelf: "center",
                  textTransform: "none",
                  color: "#009BDB",
                }}
              >
                ¿Necesitás descargar tus camiones atmosféricos en nuestra
                Planta? Mirá lo que tenés que hacer
              </p>
            </a>
          )}
          <br />
          {textsLoginPage === true && (
            <Link
              to="/register"
              style={{
                fontSize: "16px",
                lineHeight: "19px",
                fontFamily: "Roboto",

                textDecoration: "none",
                alignSelf: "center",
                textTransform: "none",
                color: "#F86436",
              }}
            >
              ¿Primera vez que ingresás?
            </Link>
          )}
        </form>
      </Container>
      <br />
    </div>
  );
};

SingleLogInForm.defaultProps = {
  actions: {
    postLogin: () => new Promise((resolve, reject) => resolve({})),
  },
  dispatch: () => {},
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      postLogin: (body) => dispatch(authActions.loginHandler(body)),
    },
  };
};

export default connect(null, mapDispatchToProps)(SingleLogInForm);
